import React from 'react';
import Table from 'react-bootstrap/Table';
import elementsofei from "../images/elements-of-ei.png";


 function EICourse(props: any) {
	   
  return (
   <div className="masthead">
		<h1>Fundamentals of Emotional Intelligence Course</h1>
		

		<h2>About This Course</h2>
		<p>MyOceanity’s course represents my life’s work and the body of knowledge I have accumulated over the past years. It’s a continuously improving project: We review the existing lessons and add new ones each week, so make sure you frequently revisit the course to see how our latest findings can help you learn better!</p>
		<p>Reviewing the lessons will help you to better memorize them and find how you can apply them during everyday situations.</p>
		<p>The course is primarily written-article-based today, and will also include audio podcasts and video courses to enrich your learning and best match your preferred learning media.</p>
		<p>You can stay updated with the changes we make to the platform by checking out our updates page, which breaks down what is new and what has changed by week.</p>

		<div className="myimghor">
			<img src={elementsofei} alt="The 4 elements of emotional intelligence" />
		</div>

		<div className="imgcaption">
			<p>The 4 elements of emotional intelligence we will discuss</p>
		</div>


		<h2>Course Curriculum</h2>
		
		<div className="course-tables-center">

		<br />

		<Table striped bordered hover>
			<thead>
				<tr><th className="course-table-header">Module 1: Introduction To Emotional Intelligence</th></tr>
			</thead>
			<tbody className="course-table-body">
				<tr> <td> <a href="/what-is-ei" className="intlink">What is emotional intelligence?</a></td> </tr>
				<tr> <td> <a href="/why-ei-matters" className="intlink">Why does emotional intelligence matter in our lives?</a></td> </tr>
				<tr> <td> <a href="/grow-your-ei" className="intlink">How can you grow your emotional intelligence skills?</a></td> </tr>
				<tr> <td> <a href="/ei-benefits-work" className="intlink">Benefits of emotional intelligence at work</a></td> </tr>
				<tr> <td> <a href="/ei-benefits-home" className="intlink">Benefits of emotional intelligence at home (WIP)</a></td> </tr>					
				<tr> <td> <a href="/strategies-for-ei" className="intlink">Strategies to build the 4 elements of emotional intelligence (WIP)</a></td> </tr>
			</tbody>
		</Table>

		<br /><br />

		<Table striped bordered hover>
			<thead>
				<tr><th className="course-table-header">Module 2: The Importance Of Emotions</th></tr>
			</thead>
			<tbody className="course-table-body">
				<tr> <td> <a href="/core-emotions" className="intlink">What are our core emotions?</a></td> </tr>
				<tr> <td> <a href="/emotional-literacy" className="intlink">How can you become more emotionally literate?</a></td> </tr>
				<tr> <td> <a href="/reading-emotions" className="intlink">How can you better read and understand how other people are feeling? (WIP)</a></td> </tr>
			</tbody>
		</Table>

		<br /><br />

		<Table striped bordered hover>
			<thead>
				<tr><th className="course-table-header">Module 3: OCEAN Personality Traits & Emotional Intelligence</th></tr>
			</thead>
			<tbody className="course-table-body">
				<tr> <td> <a href="/ocean-personality-traits" className="intlink">What are the Big Five OCEAN personality traits?</a></td> </tr>
				<tr> <td> <a href="/myoceanity-and-ei" className="intlink">How can you use MyOceanity to build your emotional intelligence?</a></td> </tr>
				<tr> <td> <a href="/oceanology" className="intlink">OCEANology</a></td> </tr>
			</tbody>
		</Table>

		<br /><br />

		<Table striped bordered hover>
			<thead>
				<tr><th className="course-table-header">Module 4: Discovering Your Identity</th></tr>
			</thead>
			<tbody className="course-table-body">
				<tr> <td> <a href="/identity-introduction" className="intlink">Introduction to the concept of Identity</a></td> </tr>
				<tr> <td> <a href="/ikigai" className="intlink">What is a meaningful life? What is Ikigai?</a></td> </tr>
				<tr> <td> <a href="/identity-mission" className="intlink">Why are you here? What is your Mission? What gives your life purpose?</a></td> </tr>
				<tr> <td> <a href="/identity-values" className="intlink">What do you stand for? What are your core values in life?</a></td> </tr>
				<tr> <td> <a href="/identity-beliefs" className="intlink">Who are you? What are your beliefs about yourself and the world around you?</a></td> </tr>
			</tbody>
		</Table>

		<br /><br />

		<Table striped bordered hover>
			<thead>
				<tr><th className="course-table-header">Module 5: Why Introspection Matters In Emotional Intelligence</th></tr>
			</thead>
			<tbody className="course-table-body">
				<tr> <td> <a href="/journaling-self-awareness" className="intlink">How journaling helps you become more aware (WIP)</a></td> </tr>
				<tr> <td> <a href="/journaling-self-development" className="intlink">How you can leverage your self-awareness to create strategies for self-development (WIP)</a></td> </tr>
				<tr> <td> <a href="/journaling-introspection" className="intlink">How introspections help us dig towards the core of our selves and why it matters (WIP)</a></td> </tr>
			</tbody>
		</Table>

		</div>


		<h2>Frequently Asked Questions</h2>


		<h3>Q: What do I get when I join MyOceanity?</h3>
		<p>You get immediate access to the entire course’s content, including the worksheets that will help you reflect and deepen your understanding of emotional intelligence.</p>
		<p>You also get immediate access to the OCEAN personality traits assessment, as well as the possibility to invite people you know to take the same assessments and compare your traits to theirs. </p>
		<p>Together, these three tools were designed to help you grow your emotional intelligence and realize your potential.</p>


		<h3>Q: Do I have to follow the course's curriculum?</h3>
		<p>Not necessarily. We designed the course to make sure that each module could build on each other, however you are free to choose which lesson you want to discover and in which order. Follow your curiosity and interests!</p>
		<p>We want the course to be self-paced, giving you the liberty to choose how quickly or deeply you want to go through it.</p>
		<p>Plus, you will never lose access to the course, which means you can take as long as you need to revisit it and discuss it with other members of the community.</p>
		<p>The more lessons and modules you explore, the greater your understanding and “aha” moments.</p>
		<p>No start date. No end date. No pressure. Only learning and development.</p>


		<h3>Q: What if I struggle to keep up or don't know where to start?</h3>
		<p>You can follow the course curriculum if you don’t know where to start.</p>
		<p>We design the curriculum and the lessons to guide the learners through reflection and experimentation. </p>
		<p>The worksheets you will find in some lessons will help you gain greater insights and put what you learn into action. </p>
		<p>You may share your lessons learned with the rest of the MyOceanity community. We are all here to help each other and to learn how to become stronger together. You are not alone!</p>

		<br /><br /><br />
		
   </div>
  )
}
export default EICourse;

